///////////////////////
// Existing Customer //
///////////////////////
// Step 1)
export const API_URL_SET_TRANSFER_OWNER_PERSONAL_DETAILS = "/shop/api/transfer/settransferownerpersonaldetails";

// Step 2)
export const API_URL_CHECK_PHONE_NUMBER_TRANSFER_OWNERSHIP = "/shop/api/transfer/phonenumberchecktransferownership";
export const API_URL_VERIFY_CODE_TRANSFER_OWNERSHIP = "/shop/api/transfer/verifycodetransferownership";

// Step 3)
export const API_URL_SET_SELECTED_ACCOUNT = "/shop/api/transfer/setselectedaccount";
export const API_URL_SET_OFFERING_CODE = "/shop/api/transfer/offeringcode";
export const API_URL_SET_KEEP_AGREEMENT = "/shop/api/transfer/keepagreement";

// Step 4)
export const API_URL_SEND_SMS = "/shop/api/transfer/sendsmsorsubmit";

// Landingpage B2B
export const API_URL_VERIFY_CODE_TRANSFER_OWNERSHIP_EXISTING_COMPANY_ADMIN =
    "/shop/api/transfer/verifycodetransferownershipexistingcompanyadmin";
export const API_URL_VERIFY_CODE_TRANSFER_OWNERSHIP_TO_B2B = "/shop/api/transfer/bedrift/verifycodetransferownership";
export const API_URL_SET_TRANSFER_DATE = "/shop/api/transfer/settransferdate";
export const API_URL_SUBMIT_TRANSFER_OWNERSHIP_ORDER_TO_B2B = "/shop/api/transfer/bedrift/submit";
export const API_URL_REJECT_TRANSFER_OWNERSHIP_ORDER_TO_B2B = "/shop/api/transfer/bedrift/rejecttransferownership";

// Landingpage
export const API_URL_SUBMIT_TRANSFER_OWNERSHIP_ORDER = "/shop/api/transfer/submit";
export const API_URL_REJECT_TRANSFER_OWNERSHIP_ORDER = "/shop/api/transfer/reject";

/////////////////////////////////////////////
// From checkout existing => existing flow //
/////////////////////////////////////////////
export const API_URL_SUBMIT_CONSENT = "/shop/api/transfer/consent/submit";
export const API_URL_REJECT_CONSENT = "/shop/api/transfer/consent/reject";

//////////////////////////
// PortIn Customer flow //
//////////////////////////
// SMS OR EMAIL
export const API_URL_SMS_OR_EMAIL = "/shop/api/transfer/portin/sendsmsoremail";

// Submit order
export const API_URL_SUBMIT_PORTIN_TRANSFER_OWNERSHIP_ORDER = "/shop/api/transfer/portin/submit";

// Reject order
export const API_URL_REJECT_PORTIN_TRANSFER_OWNERSHIP_ORDER = "/shop/api/transfer/portin/reject";

// CONSENT WHEN PORTIN OR TRANSFER TO B2B
export const API_URL_UPDATE_ORG_CONSENT_TO_B2B = "/shop/api/consent2b2b/bedrift/updateorg";
export const API_URL_UPDATE_FORMER_LEGAL_B2B = "/shop/api/formerlegal/bedrift";
export const API_URL_CONSENT_TO_B2B_BANKID_RESET = "/shop/api/consent2b2b/bankid/reset";

// new common for both transfer and portin covering both b2b and b2c
export const API_URL_FORMER_LEGAL_CONSENT_APPROVE = "/shop/api/consent/formerlegal/approve";
export const API_URL_FORMER_LEGAL_CONSENT_REJECT = "/shop/api/consent/formerlegal/reject";
export const API_URL_FORMER_LEGAL_CONSENT_SEND_CODE = "/shop/api/consent/formerlegal/sendcode";
export const API_URL_FORMER_LEGAL_CONSENT_VERIFY_CODE = "/shop/api/consent/formerlegal/verifycode";
